import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const PopupWrapper = styled.div`
  position: absolute;
  right: ${pxToRem('-8px')};
  top: ${pxToRem('25px')};
  width: ${pxToRem('178px')};
  height: auto;
  border-radius: ${pxToRem('8px')};
  box-shadow: 0 ${pxToRem('12px')} ${pxToRem('24px')} ${pxToRem('8px')}
    ${props => props.theme.colors.blue.six};
  border: solid ${pxToRem('1px')} ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  z-index: 100;
  justify-content: space-around;
  padding: ${pxToRem('10px')};
`;

export const Item = styled.div`
  padding: ${pxToRem('8px')};
  text-align: center;
  border-radius: ${pxToRem('10px')};
  display: flex;
  font-weight: 500;
  justify-content: flex-start;
  :hover {
    cursor: pointer;
    background-color: ${props => props.theme.colors.blue.five};
    font-weight: 600;
  }
  gap: ${pxToRem('10px')};
  align-items: center;
`;
